import { Male, Female } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type MemberDetailGenderProps = {
  sex: string | undefined;
  small?: boolean;
};

export const MemberDetailGender = (props: MemberDetailGenderProps) => {
  const { sex, small = false } = props;
  const { t } = useTranslation(['common']);
  if (!sex) return null;
  return (
    <Typography variant={small ? 'body2' : 'body1'} sx={{ display: 'flex', alignItems: 'center' }}>
      {sex === 'M' && (
        <>
          <Male sx={{ mr: 1 }} />
          <span>{t('dataFields.male')}</span>
        </>
      )}
      {sex === 'K' && (
        <>
          <Female sx={{ mr: 1 }} />
          <span>{t('dataFields.female')}</span>
        </>
      )}
    </Typography>
  );
};
